module.exports = __webpack_public_path__ + "img/s1-team3.59ded8ee.jpg";